import LinkIcon01 from '@untitled-ui/icons-react/build/esm/Link01';

import { Tooltip } from 'antd';
import { useToast } from 'providers/ToastProvider';
import { BaseButton } from './BaseButton';

interface RecordType {
  outreachUrl: string;
  status?: string;
}

interface LinkIconProps {
  record: RecordType;
}

export const LinkCopyButton = ({ record }: LinkIconProps) => {
  const toast = useToast();

  if (record?.status === 'Expired') {
    return null;
  }

  const fallbackCopyToClipboard = (text: string) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
      toast.success('Verification link copied to clipboard.');
    } catch {
      toast.error('Failed to copy verification link to clipboard.');
    }
    document.body.removeChild(textArea);
  };

  const handleCopyUrl = () => {
    if (!record.outreachUrl) {
      toast.warning('No verification link found.');
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(record.outreachUrl)
        .then(() => {
          toast.success('Verification link copied to clipboard.');
        })
        .catch(() => {
          fallbackCopyToClipboard(record.outreachUrl);
        });
    } else {
      fallbackCopyToClipboard(record.outreachUrl);
    }
  };

  return (
    <Tooltip title="Copy Verification Link">
      <BaseButton
        className="secondary-button min-h-8 min-w-8 "
        icon={<LinkIcon01 className="h-4 w-4" />}
        onClick={handleCopyUrl}
      ></BaseButton>
    </Tooltip>
  );
};
